var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#paint0_linear_302_962)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24.7274,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33.4541,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7273,
    y: 15.9999,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7273,
    y: 24.7274,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7273,
    y: 33.4541,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4543,
    y: 15.9999,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4543,
    y: 24.7274,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4543,
    y: 33.4541,
    width: 6.54546,
    height: 6.54546,
    rx: 1,
    fill: "#CF3F7C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_962)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 24,
    height: 24,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_962",
    x1: 56,
    y1: -0.00000265986,
    x2: 7.52491,
    y2: 57.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF3F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#314175"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/AppsIcon.55ddc45817fe92eace108f42b0adfbbb.svg";
export { ForwardRef as ReactComponent };